import React from 'react';
import MUIDataTable from 'mui-datatables';
import ShowSpinner from '../../components/ShowSpinner';

const FeatureTable = ({ features }) => {
  const getColumnSettings = () => ['Name', 'Label', 'Description'];

  const getTableSettings = () => ({
    rowHover: false,
    responsive: 'standard',
    selectableRows: 'none',
    pagination: false,
    print: false,
    download: false,
    viewColumns: false,
    elevation: 0,
  });

  const flattenAdmFeatures = (feature) => [
    feature.name,
    feature.label,
    feature.description,
  ];

  if (features) {
    const flatFeatures = features.map((f) => flattenAdmFeatures(f));

    return (
      <MUIDataTable
        columns={getColumnSettings()}
        options={getTableSettings()}
        data={flatFeatures}
        data-testid="feature-table"
      />
    );
  } else {
    return <ShowSpinner />;
  }
};

export default FeatureTable;
